export default __webpack_public_path__ + "a104a53.png";